/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/anchor-has-content */
import React from "react";

import {
  acceptedNoomClinicalOffer,
  hasMedicareInsurance,
  hasSelectedMicrodoseBiomarkerPlan,
  isCrossSellShopCheckout,
  isOtcBiomarkersInCart,
  isShopSubscriptionCheckout,
} from "src/utils/userSegment/features";
import { isUS } from "src/utils/userSegment";
import { Text } from "src/components/core/Text";
import { PaymentEnrollmentFormState } from "src/utils/redux/slices/paymentEnrollmentForm";
import {
  handleAtHomeLabsConsentClick,
  handleShopPurchaseIntentAgreementClick,
  handleTermAgreementClick,
} from "./agreementHandlers";
import { MedicareAttestationCheckboxLabel } from "./MedicareAttestationCheckboxLabel";

export interface AgreementConfig {
  key: keyof PaymentEnrollmentFormState["enrollmentInfo"];
  label: string | React.ReactNode;
  required: boolean;
  condition: () => boolean;
  dataCy?: string;
  trackingName?: string;
  onClickEffect?: (
    checked: boolean,
    enrollmentInfo: PaymentEnrollmentFormState["enrollmentInfo"]
  ) => void;
}

export const AGREEMENT_CONFIGS: AgreementConfig[] = [
  {
    key: "termAgreement",
    label: "",
    required: true,
    // Skipped for one-time shop checkouts (e.g. biomarkers), but required for
    // shop subscription checkouts (e.g. metabolic) to capture auto-renew consent.
    condition: () =>
      isUS() && (!isCrossSellShopCheckout() || isShopSubscriptionCheckout()),
    dataCy: "terms-agreement",
    trackingName: "CheckoutTermsAndConditions",
    onClickEffect: (checked, enrollmentInfo) => {
      handleTermAgreementClick(checked, enrollmentInfo);
      handleShopPurchaseIntentAgreementClick(checked);
    },
  },
  {
    key: "atHomeLabsConsent",
    label: (
      <Text
        i18nKey="payment:terms:atHomeLabsConsent"
        components={{
          ConsentLink: (
            <a
              href="/static/Ash-Patient-Consent.pdf"
              target="_blank"
              rel="noopener noreferrer"
              data-cy="at-home-labs-consent-link"
            />
          ),
        }}
      />
    ),
    required: true,
    condition: () =>
      (hasSelectedMicrodoseBiomarkerPlan() && acceptedNoomClinicalOffer()) ||
      isOtcBiomarkersInCart(),
    dataCy: "at-home-labs-consent",
    trackingName: "AtHomeLabsConsent",
    onClickEffect: handleAtHomeLabsConsentClick,
  },
  {
    key: "medicareAttestationConsent",
    label: <MedicareAttestationCheckboxLabel />,
    required: true,
    condition: () => hasMedicareInsurance() && acceptedNoomClinicalOffer(),
    dataCy: "medicare-attestation-consent",
    trackingName: "MedicareAttestationConsent",
  },
];
